module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAYAAACkTj4ZAAAA+klEQVQokZ2QsUqCURiGn9wanfohmsq9qSUEL6A7aGqssVm8AcHJ/V8CQbyCwN0rcGvQpUgIRGjTp6HvgP0cSX3gLO/3vQ/nHADUjsfTISRjtaE+q+sDBOvoNNQxEX6pLfVOXe0hWcVuK7rW+KUOvAIFcAvM2c08doro1NPTqnTVc3WSmU1i1q0OciLVkXqqDrayQWSjXOFEtXL1DXAPfAJvwEPkJXAJnAEvQO1PKyN/VJvqt/qu3sT5iKypPv33tLZ6rS63sk2cxDJ22rtEPfVKXeT+oMIidntVUaleqLM9JIlZdMok6quFOj1AkphGt58+fHiEJDEE+AHddPPcox2qfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/icono_email.png
// module id = 604
// module chunks = 0